export enum PopupResultTypes {
  Ok,
  Cancel,
  Yes,
  No,
}
